import { GetRequest, GetRequestStatus } from "../utils/repository/RequestMaker";
import Endpoints from "../utils/repository/Endpoints";


// Function to get the alarm status from the backend
export const getAlarmStatus = async () => {
    const response = await GetRequest(Endpoints.alarm_status);
   // console.log("responssss ", response.status)
    return response.status;
  };
  
  // Function to update the alarm status on the backend
 export const updateAlarmStatus = async (status) => {
    await GetRequestStatus(Endpoints.alarm_status_update + status);
  };
  